var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[(_vm.checkPermit(51, 53, 55))?_c('h2',{staticClass:"title is-2 has-text-centered"},[_vm._v("大盘数据")]):_c('h2',{staticClass:"title is-4 has-text-centered"},[_vm._v("这里啥也没有")]),(_vm.checkPermit(51, 53, 55))?_c('audible-analysis'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }